import {
  IGetCmsContentResult,
  IQuickSearchResultArticle,
  IQuickSearchResultPage,
  ISearchProviderConfig,
} from '../../../types';

/**
 * GetCmsContent
 *
 * Uses Shopify Predictive Search (pages + articles) or a dedicated
 * JSON view to return CMS content in the expected format.
 */
const GetCmsContent = (
  term: string,
  _config: ISearchProviderConfig,
): Promise<IGetCmsContentResult> =>
  new Promise<IGetCmsContentResult>((resolve) => {
    const response: IGetCmsContentResult = {
      raw: null,
      pages: [],
      articles: [],
    };

    if (!term || term.trim() === '') {
      resolve(response);
      return;
    }

    try {
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'page,article',
        'resources[limit]': '10',
      });

      fetch(`/search/suggest.json?${params.toString()}`)
        .then((r) => r.json())
        .then((data) => {
          response.raw = data;

          const resources = data?.resources || {};

          if (Array.isArray(resources.pages?.results)) {
            resources.pages.results.forEach((page: any) => {
              const base = {
                id: String(page.id),
                handle: page.handle,
                title: page.title,
                url: page.url,
              };

              if (page.url && page.url.indexOf('/blogs/') === -1) {
                response.pages.push(<IQuickSearchResultPage>base);
              } else {
                response.articles.push(<IQuickSearchResultArticle>base);
              }
            });
          }

          resolve(response);
        })
        .catch((e) => {
          console.error(e);
          resolve(response);
        });
    } catch (e) {
      console.error(e);
      resolve(response);
    }
  });

export default GetCmsContent;

